// extracted by mini-css-extract-plugin
export default {"container":"OP-z"};